import React from 'react'
import { StoryblokRichtext } from 'storyblok-rich-text-react-renderer'
import clsx from 'clsx'
import { ReactComponent as WavyLine } from '@/assets/icons/wavy_line.svg'
import { OverviewAccordion } from '@/components/molecules/OverviewBlock/OverviewAccordion'
import { OverviewTable } from '@/components/molecules/OverviewBlock/OverviewTable'
import { RichTextField } from '@/components/organisms/RichTextField/RichTextField'

export function OverviewBlock({
  items,
  table
}: {
  items: { _uid?: string; title?: string; content?: StoryblokRichtext }[]
  table: { _uid: string; title: string; value: string }[]
}) {
  return (
    <div className="relative overflow-hidden bg-primary-100 tablet-lg:rounded-xl mb-48">
      <WavyLine className="absolute top-0 left-0 w-full " />
      <WavyLine className="absolute bottom-48 left-0 w-full rotate-12 " />
      <div className="[&>*]:z-10 px-24 py-48 netbook:p-40 flex flex-col netbook:flex-wrap netbook:flex-row gap-24">
        {items && items.length > 0 && <OverviewAccordion items={items} />}
        {items &&
          items.length > 0 &&
          items.map((item, index) => (
            <div key={item._uid} className={clsx('hidden netbook:block', index === 0 && 'netbook:w-full')}>
              <h3 className={clsx('font-bold text-text-dark-900', index === 1 ? 'text-bodyL' : 'text-headingS')}>
                {item.title}
              </h3>

              <div
                className={clsx(
                  'py-24 netbook:pt-16 netbook:pb-0 text-text-dark-600 text-bodyL font-sans  [&>p]:mb-12 [&>p:has(>a)]:mb-0 [&_a]:text-text-brand-darker [&_a]:font-semibold [&_a]:inline-block [&_a]:text-bodyL',
                  index === 0 && 'overview-block',
                  index === 1 && '[&_a:not(:last-child)]:mb-16'
                )}
              >
                <RichTextField data={item.content} />
              </div>
            </div>
          ))}
        {table && table.length === 3 && <OverviewTable table={table} />}
      </div>
    </div>
  )
}
